import { Props } from './props'

export const desktopWidth = function (captchaWidth: number) {
  return function ({ columns }: Props) {
    return columns * captchaWidth
  }
}
